export const getFileSize = (file) => {
    return file.size/1024 > 1024? `${Math.round(file.size/(1024*1024))} Mb`:`${Math.round(file.size/1024)} Kb`;
}